import React, { useState } from 'react';
// import SidebarLogo from '../../assets/SVGs/SidebarLogo';
import LoginSideImg from '../../assets/SVGs/LogInSideImage';
import { useLocation } from 'react-router-dom';
import { getTimeDifference, isOvum } from './../../utils/utils'; // goBack
import { useTheme } from '../../context/ThemeContext';
import LoadingOverlay from '../insurance/LoadingOverlay';

const Login: React.FC<{
  login: (username: string, password: string) => void;
  alertMessage: any;
  setAlertMessage: any;
  loading: boolean;
}> = ({ login, alertMessage, setAlertMessage, loading }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const location = useLocation();
  const { signUp, date } = location.state || {};
  const { theme } = useTheme();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setAlertMessage(null);
    login(username.trim(), password);
  };

  return (
    <div className="min-h-screen flex flex-col overflow-hidden">
      {/* Main Content */}
      <div className="flex flex-1">
        {/* Left Side: Sign-in Form */}
        <div className="flex flex-col justify-start md:justify-center w-full md:w-[55%] bg-[#F2F5F9] p-6 lg:p-12 sm:mt-0">
          <div className="sm:px-[32px] md:px-[64px]">
            {/* <span
              className="text-gray-600 cursor-pointer text-xl font-bold"
              onClick={goBack}
            >
              ←
            </span>
            <div className="flex justify-center items-center">
              <SidebarLogo />
            </div> */}
            <h2 className="mt-10 text-left text-2xl font-semibold leading-9 text-[#29406B] sm:mt-0">
              Sign in
            </h2>
          </div>
          <div className="mt-6 sm:px-[32px] md:px-[64px]">
          {
            loading && <LoadingOverlay />
          }
          {alertMessage && (
              <div
                className={`p-4 rounded-md mb-4 ${
                  alertMessage?.type === 'success'
                    ? 'bg-green-100 text-green-700'
                    : 'bg-red-100 text-red-700'
                }`}
              >
                {alertMessage?.text}
              </div>
            )}
            {signUp && date && getTimeDifference(date) && (
              <div
                className={`p-4 rounded-md mb-4 bg-green-100 text-green-700`}
              >
                Account created successfully!
              </div>
            )}
          </div>
          <div className="mt-10 sm:px-[32px] md:px-[64px] sm:mt-0">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="username"
                  className="font-semibold text-base text-[#29406B]"
                >
                  Username
                </label>
                <div className="mt-2">
                  <input
                    id="username"
                    data-testid="username-input"
                    name="username"
                    type="text"
                    value={username}
                    onChange={(e) => {setUsername(e.target.value); setAlertMessage(null);}}
                    required
                    className="w-full bg-[white] text-[#29406B] border-1 font-medium px-4 py-3 rounded-[12px] ring-1 ring-inset ring-[#DCE1E8]"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="font-semibold text-base text-[#29406B]"
                >
                  Password
                </label>
                <div className="mt-2">
                  <input
                    id="password"
                    data-testid="password-input"
                    name="password"
                    type="password"
                    value={password}
                    onChange={(e) => {setPassword(e.target.value); setAlertMessage(null);}}
                    required
                    className="w-full bg-[white] text-[#29406B] border-1 font-medium px-4 py-3 rounded-[12px] ring-1 ring-inset ring-[#DCE1E8]"
                  />
                </div>
                <div className="w-full text-right mt-2">
                  <label className="w-full text-sm text-right font-medium text-[#E24E40]">
                    Forgot password
                  </label>
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  data-testid="sign-in-button"
                  className={`flex px-4 py-3 w-full justify-center rounded-md px-3 py-1.5 text-xl font-semibold text-[#FFFFFF] shadow-sm ${theme['button-bg']}`}
                >
                  Sign In
                </button>
              </div>

              {
                !isOvum() && (<p className="mt-10 text-center text-lg font-semibold">
                Don't have an account?{' '}
                <a
                  href="/signup"
                  className={`text-lg text-${theme.color} underline font-semibold cursor-pointer`}
                >
                  Sign up
                </a>
              </p>)
              }
            </form>
          </div>
        </div>

        <div className="hidden md:flex md:w-[45%] items-center justify-center bg-[#242E49] h-screen">
          <LoginSideImg />
        </div>
      </div>
    </div>
  );
};

export default Login;
